export default __webpack_public_path__ + "static/media/logo_funky_blanc.b39be74e.png";